/* collins-rise.js: "every page in motion", prompt 4 (21 Oct 2026, MOTION-PAGES.md). Each [data-cl-rise] line rises
   in depth once, in reading order, as its top passes 88% of the screen (collins-rise.css holds the values, the same
   as the service pages' h2s). Intent: each section announces itself as the reader reaches it, once.
     - only Newsreader lines of 29 px and up rise (MOTION-PAGES.md: labels, body copy and small headings never move),
       so a line that sets smaller on a phone stays still there
     - a line already on screen when the page opens stays at rest
     - words are split here (text nodes only; links and tags stay as they are) and put back on teardown
   No library, no scroll listener: one IntersectionObserver. Transforms only. Reduced motion (also when it is switched
   on while the page is open): nothing is split and nothing moves. Teardown on pagehide. */
(function () {
  'use strict';
  var d = document, w = window;
  var mq = w.matchMedia('(prefers-reduced-motion: reduce)');
  var S = null;

  function split(h) {
    var walker = d.createTreeWalker(h, NodeFilter.SHOW_TEXT, null), nodes = [], n, i = 0;
    while ((n = walker.nextNode())) nodes.push(n);
    nodes.forEach(function (t) {
      var parts = t.nodeValue.split(/(\s+)/), frag = d.createDocumentFragment();
      parts.forEach(function (p) {
        if (!p) return;
        if (/^\s+$/.test(p)) { frag.appendChild(d.createTextNode(p)); return; }
        var s = d.createElement('span'); s.className = 'im-w'; s.style.setProperty('--i', i++); s.textContent = p;
        frag.appendChild(s);
      });
      t.parentNode.replaceChild(frag, t);
    });
    h.classList.add('cl-rise');
    return function () {
      h.querySelectorAll('.im-w').forEach(function (s) { s.replaceWith(d.createTextNode(s.textContent)); });
      h.normalize(); h.classList.remove('cl-rise', 'im-pre', 'im-go');
    };
  }

  function init() {
    if (S || mq.matches || !('IntersectionObserver' in w)) return;
    var els = Array.prototype.slice.call(d.querySelectorAll('[data-cl-rise]'));
    if (!els.length) return;
    S = { undo: [], io: null };
    S.io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('im-go'); e.target.classList.remove('im-pre');
        S.io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -12% 0px' });
    var vh = w.innerHeight;
    els.forEach(function (h) {
      if (parseFloat(w.getComputedStyle(h).fontSize) < 29) return;
      if (h.getBoundingClientRect().top < vh * 0.88) return;
      S.undo.push(split(h));
      h.classList.add('im-pre');
      S.io.observe(h);
    });
  }
  function destroy() {
    if (!S) return;
    var s = S; S = null;
    s.io.disconnect();
    for (var i = s.undo.length - 1; i >= 0; i--) { try { s.undo[i](); } catch (e) {} }
  }

  var mqChange = function () { destroy(); if (!mq.matches) init(); };
  if (mq.addEventListener) mq.addEventListener('change', mqChange); else if (mq.addListener) mq.addListener(mqChange);
  w.addEventListener('pagehide', destroy);
  w.addEventListener('pageshow', function (e) { if (e.persisted) init(); });
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
